import { initialize, trackEvent, trackPageView } from './Snowplow'

/**
 * The analytics props is expect to contain:
 * {
 *   event: {
 *     schema: "event schema uri",
 *     data: {...}
 *   },
 *   contexts: [
 *     {
 *       schema: "context 1 schema uri",
 *       data: {...}
 *     },
 *     {
 *       schema: "context 2 schema uri",
 *       data: {...}
 *     }
 *   ]
 * }
 */
class Analytics {
  constructor(analytics, defaultAnalytics) {
    this.analytics = Object.assign({}, defaultAnalytics, analytics)

    if (global.window && !window.snowplow) {
      initialize()
    }
  }

  // The data object should contain the user action and any component specific
  // state that should be tracked
  event(data) {
    this.analytics.action = data

    trackEvent(this.analytics)
  }
}

export {Analytics}

export default Analytics
